import { AxiosInstance } from 'axios';
import { PtoSchedule } from '../../types';

export function createPtoScheduleApi(client: AxiosInstance) {
  return {
    async getPtoSchedules(employeeId: number) {
      const r = await client.get(`/employees/${employeeId}/pto-schedules`);
      return r.data as PtoSchedule[];
    },
    async createPtoSchedule(params: {
      employee_id: number;
      project_id: number;
      start_date: string;
      end_date: string;
      hours_per_day?: number;
      note?: string;
    }) {
      const r = await client.post('/pto-schedules', params);
      return r.data as PtoSchedule;
    },
    async cancelPtoSchedule(id: number) {
      const r = await client.delete(`/pto-schedules/${id}`);
      return r.data as { ok: boolean };
    },
  };
}

export type PtoScheduleApi = ReturnType<typeof createPtoScheduleApi>;
